import OrientationHelper from './orientation.helper'

export {
    OrientationHelper
}

export default  {
    OrientationHelper
}